import React from 'react';
import {
  formatCpf, formatPlate, formatDate,
} from '../../../utils';
import Flex, { Grid } from '../../../components/Flex';
import CopyToClipboard from '../../../components/CopyToClipboard';
import { Container } from './styles';

import { IOrder } from '../../../interfaces';

const Reported: React.FC<{order: IOrder}> = ({ order }) => (
  <Container>
    <Grid container spacing={1}>
      {order.type === 'vehicle' && (
      <>
        <Flex title="Placa" xs={6} sm={4} md={4}>
          <CopyToClipboard text={order.plate}>
            {formatPlate(order.plate)}
          </CopyToClipboard>
        </Flex>
        <Flex title="Chassi" xs={6} sm={4} md={4}>
          <CopyToClipboard text={order.chassi}>
            {order.chassi || 'Não informado'}
          </CopyToClipboard>
        </Flex>
        <Flex title="Motor" xs={6} sm={4} md={4}>
          <CopyToClipboard text={order.chassi}>
            {order.engine_number || 'Não informado'}
          </CopyToClipboard>
        </Flex>
        <Flex title="Marca/Modelo" xs={6} sm={4} md={4}>
          <CopyToClipboard text={order.brand}>
            {order.brand || 'Não informado'}
          </CopyToClipboard>
        </Flex>
        <Flex title="Cor" xs={4} sm={3} md={3}>
          <CopyToClipboard text={order.color}>
            {order.color || 'Não informada'}
          </CopyToClipboard>
        </Flex>
        <Flex title="Observações" xs={6} sm={8} md={12}>
          {order.description || 'Não informado'}
        </Flex>
      </>
      )}

      {order.type === 'person' && (
      <>
        <Grid container spacing={2}>
          <Grid item>
            <div style={{ width: 120, height: 120, overflow: 'hidden', borderRadius: 8 }}>
              {order?.foto ? (
                <img
                  src={order.foto}
                  alt="Foto consulta"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    borderRadius: 8,
                  }}
                />
              ) : (
                <div style={{ 
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: 8,
                  background: '#d8d8d8' 
                }}>
                </div>
              )}
            </div>
          </Grid>
          <Grid item xs={10}>
            <Grid container item xs={12} spacing={4}>
              <Flex title="CPF" textAutoSize>
                <CopyToClipboard text={order.document}>
                  {formatCpf(order.document)}
                </CopyToClipboard>
              </Flex>
              <Flex title="RG" textAutoSize>
                <CopyToClipboard text={order.document_secondary}>
                  {order.document_secondary}
                </CopyToClipboard>
              </Flex>
              <Flex title="Nome" textAutoSize>
                <CopyToClipboard text={order.name}>
                  {order.name}
                </CopyToClipboard>
              </Flex>
            </Grid>
            <Grid container item xs={12} spacing={4}>
              <Flex title="Nascimento">
                <CopyToClipboard text={order.birthday ? formatDate(order.birthday) : ''}>
                  {order.birthday ? formatDate(order.birthday) : 'não informado'}
                </CopyToClipboard>
              </Flex>
              <Flex title="Mãe" textAutoSize>
                  <CopyToClipboard text={order.mather}>
                    {order.mather}
                  </CopyToClipboard>
                </Flex>
                <Flex title="Pai" textAutoSize>
                  <CopyToClipboard text={order.father}>
                    {order.father}
                  </CopyToClipboard>
                </Flex>
            </Grid>
          </Grid>
        </Grid>
      </>
      )}
       <Flex title="Gerência" xs={12} sm={4} textAutoSize>
        { order.management?.initials }
        { order.sector && ` - ${order.sector?.initials}` }
      </Flex>
      <Flex title="Solicitado por" xs={12} sm={8} textAutoSize>
        {` ${formatCpf(order.user?.document)} - ${order.user?.first_name}, ${order.user?.phone}`}
      </Flex>
    </Grid>
  </Container>
);

export default Reported;
